import { useCompany } from '../../context/CompanyContext';
import { footerFixed, footerRelative } from './FooterStyles';

import { version } from '../../version';

function Footer({ fixed = true }) {
  const style = fixed ? footerFixed : footerRelative;
  const { company } = useCompany();

  return (
    <footer style={style}>
      <div className="d-flex w-100 container-fluid px-2" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>

        {/* Main Content Container: Centered on Mobile, Split on Desktop */}
        <div className="d-flex flex-nowrap align-items-center justify-content-center justify-content-md-between w-100 gap-1 text-white-50 small py-1">

          {/* Left Side Group */}
          <div className="d-flex align-items-center gap-1">
            <span className="text-nowrap">&copy; {new Date().getFullYear()} <span className="fw-bold text-light">JC&Retenciones</span></span>
            <span className="text-secondary opacity-50">|</span>
            {company ? (
              <span className="text-info opacity-75 text-nowrap">{company.razon_social}</span>
            ) : (
              <span className="text-nowrap">Todos los derechos reservados</span>
            )}
          </div>

          {/* Separator - Visible ONLY on Mobile to separate the focused groups */}
          <span className="text-secondary opacity-50 mx-1 d-md-none">|</span>

          {/* Right Side Group */}
          <div className="d-flex align-items-center gap-1">
            <a href="mailto:soporte@jcretenciones.com" className="text-decoration-none text-light opacity-75 hover-opacity-100 transition-opacity text-nowrap d-flex align-items-center">
              <i className="bi bi-envelope me-1"></i> <span className="d-none d-sm-inline">Soporte</span><span className="d-sm-none">Soporte</span>
            </a>
            <span className="text-secondary">|</span>
            <span className="badge bg-black bg-opacity-25 border border-secondary border-opacity-25 fw-normal font-monospace px-1 py-0">
              v{version}
            </span>
          </div>

        </div>

      </div>
    </footer>
  );
}

export default Footer;